import { observer } from "mobx-react-lite";
import * as React from "react";
import { SelectFromModalButton } from "src/components/SelectFromModalButton/SelectFromModalButton";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";
import { ZSidLabel, zSidLabel } from "src/types";
import { ActivateCallback } from "src/types/ActivateCallback";

import { StdLink } from "../../StdLink/StdLink";
import { ZTypeDef } from "../../ZAttrMeta";
import { ZAttrRecordSelect } from "../ZAttrComponent";
import { AttrRecordSelectModal } from "./AttrRecordSelectModal";

const makeLink = ({ id, label }: ZSidLabel) => (
  <StdLink href={makeUrl(PageUrl.editRecord, { id })}>{label}</StdLink>
);

type PropsAttrRecordSelect = {
  attrType: ZTypeDef;
  component: ZAttrRecordSelect;
  value?: unknown; // strOption for single mode, and strOption[] for multi mode. Nullable in any case
  onChange?(newValue: unknown): void;
  disabled?: boolean;
  activateCallback?: ActivateCallback;
  onBlur(): void;
};

export const AttrRecordSelect: React.FC<PropsAttrRecordSelect> = observer(
  (props) => {
    const {
      attrType,
      component,
      value,
      onChange,
      disabled,
      activateCallback,
      onBlur,
    } = props;
    let typedValue: ZSidLabel | ZSidLabel[] | null = null;
    let multi = false;
    let options: ZSidLabel[] = [];

    if (attrType.name === "strOption") {
      const res = zSidLabel.safeParse(value);
      if (res.success) {
        typedValue = res.data;
        options = [typedValue];
      }
    } else if (
      attrType.name === "array" &&
      attrType.item?.type.name === "strOption"
    ) {
      multi = true;
      const res = zSidLabel.array().safeParse(value);
      if (res.success) {
        typedValue = res.data;
        options = typedValue;
      }
    }

    const makeValue = (
      list: ZSidLabel[] | null,
    ): ZSidLabel | ZSidLabel[] | null => (multi ? list : (list?.[0] ?? null));

    const [open, setOpen] = React.useState(false);
    return (
      <SelectFromModalButton
        disabled={disabled}
        options={options}
        multi={multi}
        onOpen={() => setOpen(true)}
        onChange={(newValue) => onChange?.(makeValue(newValue))}
        activateCallback={activateCallback}
        makeTagLabel={makeLink}
        onBlur={onBlur}
      >
        <AttrRecordSelectModal
          open={open}
          close={() => setOpen(false)}
          catalogId={component.catalogId}
          labelTemplate={component.labelTemplate}
          srcValue={typedValue}
          multi={multi}
          onOk={(newValue) => {
            onChange?.(newValue);
          }}
        />
      </SelectFromModalButton>
    );
  },
);
